import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getPostGameResultOverlayStyles = (theme: Theme) => {
  return StyleSheet.create({
    // Dialog card
    // Width is set inline by the component (capped to the viewport) so it never
    // overflows on narrow mobile-browser widths.
    card: {
      backgroundColor: theme.background.card,
      borderRadius: 20,
      paddingTop: 28,
      paddingBottom: 20,
      paddingHorizontal: 24,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: theme.gray[200],
    },

    // Avatar
    avatarWrap: {
      width: 140,
      height: 140,
      marginBottom: 12,
    },

    // Headline
    headline: {
      fontSize: 32,
      fontWeight: '900',
      letterSpacing: -0.5,
      color: theme.gray[900],
      marginBottom: 4,
      textAlign: 'center',
    },
    headlineWon: {
      color: theme.success,
    },
    // A miss is neutral/muted — deliberately not red, since it's not a loss.
    headlineMiss: {
      color: theme.gray[600],
    },

    // Outcome badge row (badge + optional boost pill side by side)
    badgeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginBottom: 28,
      marginTop: 4,
    },
    outcomeBadge: {
      paddingHorizontal: 12,
      paddingVertical: 4,
      borderRadius: 20,
    },
    outcomeBadgeHit: { backgroundColor: theme.success },
    outcomeBadgeResult: { backgroundColor: theme.info },
    outcomeBadgeMiss: { backgroundColor: theme.error },
    outcomeBadgeText: {
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 1,
      color: theme.background.primary,
    },
    boostBadge: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 20,
      backgroundColor: '#FEF08A',
    },
    boostBadgeText: {
      fontSize: 12,
      fontWeight: '800',
      color: '#92400E',
    },

    // Match row: home team — score — away team
    matchRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      marginBottom: 24,
      width: '100%',
    },
    teamBlock: {
      flex: 1,
      alignItems: 'center',
      gap: 6,
    },
    flagWrap: {
      width: 44,
      height: 44,
    },
    teamName: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[700],
      textAlign: 'center',
    },
    scoreBlock: {
      alignItems: 'center',
      minWidth: 56,
    },
    scoreRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    scoreNum: {
      fontSize: 28,
      fontWeight: '900',
      color: theme.gray[900],
    },
    scoreDash: {
      fontSize: 22,
      fontWeight: '400',
      color: theme.gray[400],
    },
    scorePens: {
      fontSize: 11,
      color: theme.gray[500],
      marginTop: 2,
    },
    scoreRegLabel: {
      fontSize: 10,
      color: theme.gray[400],
      marginTop: 2,
    },
    boostChip: {
      marginTop: 6,
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 20,
      backgroundColor: '#FEF08A',
    },
    boostChipText: {
      fontSize: 11,
      fontWeight: '800',
      color: '#92400E',
    },

    // Divider
    divider: {
      width: '100%',
      height: StyleSheet.hairlineWidth,
      backgroundColor: theme.gray[200],
      marginBottom: 20,
    },

    // Points row
    pointsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      marginBottom: 32,
    },
    pointsLabel: {
      fontSize: 14,
      color: theme.gray[500],
    },
    pointsValue: {
      fontSize: 24,
      fontWeight: '900',
    },
    pointsValuePos: {
      color: theme.success,
    },
    pointsValueNeg: {
      color: theme.gray[400],
    },

    // Dismiss button
    dismissButton: {
      width: '100%',
      paddingVertical: 16,
      borderRadius: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.accent,
    },
    dismissButtonPressed: {
      opacity: 0.8,
    },
    dismissLabel: {
      fontSize: 16,
      fontWeight: '800',
      color: theme.background.primary,
    },
  });
};
